import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { compressAddressesTree } from "../../../utils/compressAddressesTree";

const bindAddresses = async (addresses, addressesTree, votingId) => {
	await client.post(
		"/Voting/bind",
		{
			VotingId: votingId,
			Binds: compressAddressesTree(addresses, addressesTree),
		},
		{
			headers: authHeader(),
		}
	);
};

export default bindAddresses;
